<template>
  <button
    type="button"
    class="doc-row"
    :class="`doc-row--${status}`"
    @click="$emit('open')"
  >
    <div class="doc-row__icon" aria-hidden="true">
      <i :class="iconClass" />
    </div>
    <div class="doc-row__body min-w-0">
      <div class="doc-row__title-row">
        <span class="doc-row__title">{{ title }}</span>
        <span
          v-if="statusLabel"
          class="doc-row__status"
          :class="`doc-row__status--${status}`"
        >
          {{ statusLabel }}
        </span>
      </div>
      <div v-if="chips.length" class="doc-row__chips">
        <span
          v-for="chip in chips"
          :key="chip.name"
          class="doc-row__chip"
          :class="chip.filled ? 'doc-row__chip--ok' : 'doc-row__chip--missing'"
        >
          <i :class="chip.filled ? 'pi pi-check' : 'pi pi-times'" />
          {{ chip.name }}
        </span>
      </div>
    </div>
    <span class="doc-row__action" aria-hidden="true">
      <i class="pi pi-eye" />
    </span>
  </button>
</template>

<script>
import {
  getDocumentationDocStatus,
  getDocumentationDocStatusLabel,
  getDocumentationFieldChips,
} from "../../utils/clientDocumentationStatus";

export default {
  name: "DocumentationDocRow",
  props: {
    documentation: { type: Object, required: true },
  },
  emits: ["open"],
  computed: {
    title() {
      return (
        (this.documentation.documentationType &&
          this.documentation.documentationType.name) ||
        "Documentação"
      );
    },
    status() {
      return getDocumentationDocStatus(this.documentation);
    },
    statusLabel() {
      return getDocumentationDocStatusLabel(this.status);
    },
    chips() {
      return getDocumentationFieldChips(this.documentation);
    },
    iconClass() {
      const name = this.title.toLowerCase();
      if (name.includes("iban") || name.includes("banco"))
        return "pi pi-building";
      if (
        name.includes("nif") ||
        name.includes("senha") ||
        name.includes("finanças")
      )
        return "pi pi-lock";
      return "pi pi-id-card";
    },
  },
};
</script>

<style scoped lang="scss">
.doc-row {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.55rem;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 1px 2px rgb(15 23 42 / 5%);
  }

  &--error {
    border-color: #fecaca;
    background: #fffafa;
  }

  &--warning {
    border-color: #fde68a;
    background: #fffbeb;
  }

  &--success {
    border-color: #bbf7d0;
    background: #f0fdf4;
  }
}

.doc-row__icon {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.45rem;
  background: #f1f5f9;
  color: #475569;
  font-size: 0.8rem;

  .doc-row--error & {
    background: #fee2e2;
    color: #b91c1c;
  }

  .doc-row--warning & {
    background: #ffedd5;
    color: #c2410c;
  }

  .doc-row--success & {
    background: #dcfce7;
    color: #15803d;
  }
}

.doc-row__body {
  flex: 1;
}

.doc-row__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.3rem;
}

.doc-row__title {
  font-weight: 600;
  color: #0f172a;
  font-size: 0.82rem;
  line-height: 1.25;
}

.doc-row__status {
  display: inline-flex;
  align-items: center;
  padding: 0.05rem 0.35rem;
  border-radius: 0.25rem;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: none;

  &--warning {
    background: #ffedd5;
    color: #c2410c;
  }

  &--error {
    background: #fee2e2;
    color: #b91c1c;
  }
}

.doc-row__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.doc-row__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.1rem 0.35rem;
  border-radius: 0.25rem;
  font-size: 0.65rem;
  font-weight: 600;
  line-height: 1.2;

  i {
    font-size: 0.55rem;
  }

  &--ok {
    background: #dcfce7;
    color: #166534;
  }

  &--missing {
    background: #fee2e2;
    color: #991b1b;
  }
}

.doc-row__action {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #64748b;
  margin-top: 0.1rem;
  font-size: 0.85rem;
}
</style>
